import type { InitialLoginResponseTokenPayload } from '@/services/apis/auth/auth.types';
import { jwtDecode } from 'jwt-decode';

export const jwtDecodeCustomerId = (accessToken: string) => {
  try {
    const { customer_id: customerId } =
      jwtDecode<InitialLoginResponseTokenPayload>(accessToken);
    return customerId;
  } catch (e) {
    console.error('Error decoding JWT', e);
    return '';
  }
};
